import logError from './logError'
import setDebugInfo from './setDebugInfo'

export { logError, setDebugInfo }
